import actions from './actions';
import mutations from './mutations';

const data = {
    namespaced: true,
    state: {
        brands: [],
        establishments: [],
        operators: [],
        brandOptions: null,
        optionClasses: [],
        districts: [],
        companies: [],
        drawer: false,
        driverCommissionSystems: [],
        deliveryConfidenceLevels: [],
        driverCommissions: [],
        paymentTypes: [],
        currentBranch: null
    },
    mutations,
    actions
};

export default data;
